import styled from 'styled-components';

export const Wrapper = styled.div`
  overflow: hidden;
  width: 100%;
`;

export const CellText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
`;

export const MultiLineContainer = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.4;
  padding: 4px 0;
`;

export const LineText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
`;

export const TooltipMessage = styled.span`
  white-space: pre-line;
`;
